import React, { useRef } from "react";
export function RadioButton({ alternative, checked, onChange, inputName, "data-test-id-partial": dataTestIdPartial, index, }) {
    const ref = useRef(null);
    const dataTestId = dataTestIdPartial !== undefined
        ? dataTestIdPartial + "-" + index
        : undefined;
    return (React.createElement(React.Fragment, { key: `${alternative.text}-${index}` },
        React.createElement("input", { id: `${inputName}_${index}`, type: "radio", name: inputName, checked: checked, disabled: alternative && alternative.disabled, onChange: () => onChange(alternative) }),
        React.createElement("label", { htmlFor: `${inputName}_${index}`, ref: ref, "data-test-id": dataTestId },
            React.createElement("span", { className: "box" }),
            React.createElement("span", { className: "text" }, alternative.text))));
}
